import { render, staticRenderFns } from "./PreviewJudgeechoiceModule.vue?vue&type=template&id=0e8104df&scoped=true&"
import script from "./PreviewJudgeechoiceModule.vue?vue&type=script&lang=js&"
export * from "./PreviewJudgeechoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./PreviewJudgeechoiceModule.vue?vue&type=style&index=0&id=0e8104df&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8104df",
  null
  
)

export default component.exports